export default __webpack_public_path__ + "static/media/popup-communication-image.fc198259.png";